import React, { useEffect, useState } from "react";
import {
  Accordion,
  AccordionSummary,
  Button,
  Card,
  CardContent,
  Typography,
  Grid,
  TextField,
  Alert, 
  AlertTitle, 
  AlertProps,
  Backdrop,
  CircularProgress,
} from "@mui/material";
import { Theme, useTheme } from '@mui/material/styles'
import { createStyles, makeStyles } from '@mui/styles';
import { useLocalStorage } from "../../utils/LocalStorageHook";
import {downloadMaterialCSV,makeHttpTrigger} from "../../utils/GetAdmin";
import {uploadImageValidCSV} from "../../utils/PostAdmin"
import {checkForRole} from "../../utils/GetAuth";

import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';


import {
  Lock,
  GetApp,
  ExpandMore,
  Attachment,
  Publish,
  Help,
 } from '@mui/icons-material';

 import DownloadIcon from '@mui/icons-material/Download';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    centerDiv: {
      textAlign: "center",
    },
    accordion: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(1),
    },
    root: {},
    divWidth: {
      width: "100%",
    },
    card: {
    },
    primary: {
      marginTop: theme.spacing(2),
    },
    gridSpaceable: {
      padding: theme.spacing(2),
    },
    gridMarginTop: {
      marginTop: theme.spacing(2),
    },
    paragraph: {
      padding: theme.spacing(1),
    },
    paragraphAct: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
    },
    paragraphButton: {
      marginLeft: theme.spacing(2),
      minWidth: 160,
    },
    input: {
      paddingLeft: "20px", 
      paddingRight: "20px", 
      width:"350px"
    },
    paper: {
        position: 'absolute',
        backgroundColor: theme.palette.background.paper,
        border: `1px solid`,
        borderColor: theme.palette.border.main, 
        boxShadow: theme.shadows[4],
        padding: theme.spacing(2, 2, 2),
    },
  })
);

export default function AdminValidateImages() {
  const classes = useStyles();
  const [clientId,] = useLocalStorage("SETTINGS.clientId", "100");
  const [salesOrg,] = useLocalStorage("SETTINGS.salesOrg", "");
  
 
  const [fileName, setfileName] = React.useState<string>();

  const [data, setData] = useState<any[]>([]);

  const [selectedFile, setSelectedFile] = React.useState<File>();
  const [backdropLoader, setBackdropLoader] = React.useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const [count, setCount] = useState({success:0,failed:0});
  
  const getImageBase64 = async (url: string): Promise<string> => {
    const response = await fetch(url);
    const blob = await response.blob();
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result as string);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  };
function handleHttpTrigger() {

   makeHttpTrigger(salesOrg);
    }
  const generateExcelWithImages = async (data:any[]) => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Sheet1');
  
    // Define columns
    worksheet.columns = [
      { header: 'Material', key: 'Material', width: 20 },
      { header: 'Material Description', key: 'Description', width: 20 },
      { header: 'Image', key: 'image' },
      { header: 'Modified Date', key: 'Modified Date', width: 20 }, 
      { header: 'Size(KB)', key: 'size', width: 10 },
      { header: 'Height', key: 'Height', width: 10 },
      { header: 'Width', key: 'Width', width: 10 },
      { header: 'Pack Type', key: 'Pack Type', width: 10 },
      { header: 'Pack Size', key: 'Pack Size', width: 10 },
      { header: 'VS Image', key: 'image' },
    ];
    let maxWidth: number = 0; let maxHeight =172; let vsImageBase64=''; let rowHeight: number = 0;
    for (let i = 0; i < data.length; i++) {

      
     if(data[i].vsurl){
       vsImageBase64 = await getImageBase64(data[i].vsurl);
     }

      if((data[i].vsurl) !== ""){
        const vsImageId = workbook.addImage({
        base64: vsImageBase64,
        extension: 'png',
      });
      worksheet.addImage(vsImageId, {
        tl: { col: 9, row: i+1 }, // Top-left corner (cell position)
        ext: { width: 40, height: 80 },
        editAs: 'oneCell', 
      });
       }

      if((data[i].url) !== ""){
        const imageBase64 = await getImageBase64(data[i].url);
      const dimensions = await getImageDimensions(imageBase64);
      const width = dimensions?.width ?? 0;
      const height = dimensions?.height ?? 0;
                // Convert dimensions to Excel units
      const columnWidth = pixelsToExcelColumnWidth(width);  // For column width
      rowHeight = pixelsToExcelRowHeight(height);    // For row height
       if (columnWidth > maxWidth) {
        maxWidth = columnWidth;
    }
      if (height < maxHeight) {
        maxHeight = height;
      }
      const imageId = workbook.addImage({
        base64: imageBase64,
        extension: 'png',
      });
      worksheet.addImage(imageId, {
        tl: { col: 2, row: i+1 }, // Top-left corner (cell position)
        ext: { width: 40, height: 80 },
        editAs: 'oneCell', 
      });
      
      worksheet.getCell(`A${i + 2}`).value = data[i]?.name || ''; 
      worksheet.getCell(`B${i + 2}`).value = data[i]?.desc || ''; 
      worksheet.getCell(`D${i + 2}`).value = data[i]?.modifiedDate || '';
      worksheet.getCell(`E${i + 2}`).value = data[i]?.size || '';
      worksheet.getCell(`F${i + 2}`).value = height; 
      worksheet.getCell(`G${i + 2}`).value = width; 
      worksheet.getCell(`H${i + 2}`).value = data[i]?.packType || ''; 
      worksheet.getCell(`I${i + 2}`).value = data[i]?.packSize || ''; 

    }else{
      worksheet.getCell(`A${i + 2}`).value =  data[i]?.name; 
      worksheet.getCell(`B${i + 2}`).value =data[i]?.desc; 
      worksheet.getCell(`C${i + 2}`).value = '';
      worksheet.getCell(`D${i + 2}`).value = ''; 
      worksheet.getCell(`E${i + 2}`).value = '';
      worksheet.getCell(`F${i + 2}`).value = ''; 
      worksheet.getCell(`G${i + 2}`).value = ''; 
      worksheet.getCell(`H${i + 2}`).value = ''; 
      worksheet.getCell(`I${i + 2}`).value = '';
       worksheet.getCell(`J${i + 2}`).value = '';
    }
      
      // Set column width and row height based on image dimensions
      //worksheet.getColumn('C').width = 60; // Set width of column 2
       //worksheet.getColumn('J').width = 60;
      worksheet.getRow(i+ 2).height = 100; 
      

    }
  
    const buffer = await workbook.xlsx.writeBuffer();
    saveAs(new Blob([buffer]), 'excel-with-images.xlsx');
    setBackdropLoader(false);
  };

    function handleExport() {
          setBackdropLoader(true);
          generateExcelWithImages(data);
    }

  return ( 
    <div className={classes.root}>
      <Backdrop sx={{ color: "#fff", zIndex: (theme: any) => theme.zIndex.drawer + 1 }} open={backdropLoader}>
          <CircularProgress color="primary" />
        </Backdrop>
      <Typography variant="h4"  align="center" className={classes.paragraph}>
        Validate Material Images
      </Typography>
      <Typography
        variant="subtitle1"
        className={classes.paragraphAct}
        paragraph
      >
        We will use it to validate the images against the material IDs,provided as part of uploaded template.
        The Images would be  sourced from Image repository.It would help us identify if the material images are proper or missing.
        {/* <strong>Use this tool with caution as you will need to manually delete once created. </strong>  */}
      </Typography>
      <Grid container spacing={2} className={classes.primary}>
          <Grid item xs={12} md={12} xl={12}>
            <Accordion className={classes.accordion}>
              <AccordionSummary
                expandIcon={<ExpandMore />}
                aria-controls="panel1a-content"
                id="panel1a-header"
              >
                <Typography variant="h5" className={classes.paragraph}>
                  <Help /> How to Use
                </Typography>
              </AccordionSummary>
            </Accordion>
          </Grid>
          <Grid item xs={'auto'} md={'auto'} xl={'auto'}>
            <Card className={classes.card}>
              <CardContent>
              <Typography variant="h5" className={classes.paragraph}>
                Image Verification
              </Typography>
                <div>
                  <Button
                    color="primary"
                    variant="contained"
                    className={classes.paragraphButton}
                    onClick={(event) => {
                        downloadMaterialCSV(salesOrg).then( reply => {
                          const url = window.URL.createObjectURL( new Blob([reply.data], {type: 'text/csv'}));
                          const link = document.createElement('a');
                          link.href = url;
                          link.setAttribute('download', `Validate_Material_Image_template.csv`);
                          document.body.appendChild(link);
                          link.click();
                        })
                      }
                    }
                  >
                    <GetApp/> Get Template
                  </Button>

                  <Button
                    color="primary"
                    variant="contained"
                    className={classes.paragraphButton}
                    onClick={handleHttpTrigger}
                  >
                  Trigger Image Repo Update
                  </Button>
                </div>
                <br/>
                <div className={classes.divWidth}>
                    <Button
                      color="primary"
                      component="label"
                      variant="contained"
                      style={{marginRight:10}}
                      className={classes.paragraphButton}>
                      <Attachment style={{marginRight:3}} /> Select File
                      <input type="file" name="banks" id='bank-file' 
                        hidden
                        onChange={(e) => {
                          setSelectedFile(undefined)
                          if(e.target.files){
                            setSelectedFile(e.target.files[0]);
							setfileName(e.target.files[0].name);
							e.target.value = "";
                          } 
                        }
                      }/>
                    </Button>
                    <TextField placeholder='File' type='text' value={fileName} />
                    
                    <Button
                        color="primary"
                        variant="contained"
                        className={classes.paragraphButton}
                        disabled={(selectedFile)?false:true}          
                        onClick={(event) => {
                            if(selectedFile){
                              setBackdropLoader(true)
                              uploadImageValidCSV(salesOrg,selectedFile).then((result) => {
                                setBackdropLoader(false)
                                // setData(result?.data?.message);
                                if(result && result?.data?.status == 'S'){
                                  setData(result?.data?.message);
                                  setCount(result?.data?.count);
                                  setError('');

                                } else {
                                  setError(result?.data?.message);
                                }                                
                              })
                            }
                          }
                        }
                      >
                        <Publish/> Upload
                    </Button>
                  </div>
                  
                      
                  { data?.length > 0 && !error ? <div>
                    <p>  {'Summary'} </p>
                       <p>{ 'Success : ' +count.success}</p> 
                       <p>{  'Failed : ' +count.failed }</p> 
                  </div> : null } 
                  
                  <div>
                    {error && error.length>0 && <p>{error}</p>}
                  </div>
<div>
{ <Button  variant="contained"
      color="primary"
      startIcon={<DownloadIcon />} onClick={handleExport}  disabled={(data?.length > 0 && !error )?false:true} >Export</Button>
     }
      </div>
                 
                </CardContent>
              </Card>
            </Grid>

      </Grid>
    </div>
   
  );
}

async function getImageDimensions(imageBase64:any) {
  try {
      const image:any = await loadImage(imageBase64); // Example function
      const width = image.width || 0;
      const height = image.height || 0;
      return { width, height };
  } catch (error) {
      return { width: 0, height: 0 }; // Default values
  }
}

function loadImage(imageBase64:any) {
  return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => resolve(img);
      img.onerror = (error) => reject(error);
      img.src = imageBase64;
  });
}

function pixelsToExcelColumnWidth(pixels: number): number {
  return pixels / 7; // Approximate conversion factor; adjust as needed
}

function pixelsToExcelRowHeight(pixels: number): number {
  return pixels * 1; // Approximate conversion factor; adjust as needed
}